import React from 'react';
import type { DispensaryRiskRating } from '@gcv/shared';
import { Box, Typography } from '@mui/material';

import { RatingChip } from 'ui/atoms/RatingChip/rating-chip.atom';
import palette from 'ui/theme/palette';

export interface ScoreDisplayProps {
  /** The computed 0-100 score. Undefined renders the unrated state. */
  score?: number;
  rating?: DispensaryRiskRating;
  /** False shows the rating on its own, for surfaces that do not carry a number. */
  showScore?: boolean;
  dataCy?: string;
}

export const ScoreDisplay: React.FC<ScoreDisplayProps> = (props) => {
  const withScore = props.showScore ?? true;
  const hasScore = withScore && typeof props.score === 'number';
  const showRating = !!props.rating && props.rating !== 'none';
  const showEmpty = !hasScore && !showRating;

  return (
    <Box data-cy={props.dataCy ?? 'score-display'} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {showRating && <RatingChip rating={props.rating} />}

      {hasScore && (
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
          <Typography
            sx={{ fontSize: '1.75rem', fontWeight: 700, color: palette.text.primary, lineHeight: 1 }}
          >
            {props.score}
          </Typography>
          <Typography sx={{ fontSize: '0.875rem', color: palette.text.secondary }}>/ 100</Typography>
        </Box>
      )}

      {showEmpty && (
        <Typography sx={{ fontSize: '0.875rem', color: palette.text.secondary, fontStyle: 'italic' }}>
          {withScore ? 'Not yet scored' : 'Not yet rated'}
        </Typography>
      )}
    </Box>
  );
};
